import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './data-grid.module.scss';
const DataGridCell = ({ value, border, fixedHeight, formatter, isHeader, zebra, }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const columnClass = useMemo(() => {
        return classNames(styles.cell, {
            [styles.cell_border]: border,
            [styles.dark]: isDarkMode,
        });
    }, [border]);
    const cellClass = useMemo(() => {
        return classNames(styles.cell_val, {
            [styles.cell_val_fixed]: fixedHeight,
            [styles.dark]: isDarkMode,
        }, isHeader ? styles.header : '');
    }, [isHeader]);
    return (_jsx("div", { className: columnClass, role: "cell", children: _jsx("span", { className: classNames(styles.cell_wrapper, zebra ? styles.zebra : '', isDarkMode ? styles.dark : ''), children: _jsx("span", { className: cellClass, dangerouslySetInnerHTML: {
                    __html: formatter
                        ? formatter(value)
                        : value,
                } }) }) }));
};
DataGridCell.displayName = 'DataGridCell';
export { DataGridCell };
